"use client"

import { useEffect, useState } from "react"
import styles from "./ServicesSection.module.css"

function ServicesSection() {
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const services = [
    { title: "Consulta Dermatológica", description: "Evaluación y diagnóstico de condiciones de la piel." },
    {
      title: "Tratamientos Estéticos",
      description: "Procedimientos no invasivos para mejorar la apariencia de la piel.",
    },
    {
      title: "Cirugía Dermatológica",
      description: "Procedimientos quirúrgicos para tratar diversas condiciones de la piel.",
    },
  ]

  const titleY = scrollY * 0.1 // Adjust this value to control the parallax speed

  return (
    <section id="services" className={styles.ServicesSection}>
      <div className={styles.container}>
        <h2 className={styles.sectiontitle} style={{ transform: `translateY(${titleY}px)` }}>
          Nuestros Servicios
        </h2>
        <div className={styles.servicesgrid}>
          {services.map((service, index) => {
            const cardY = scrollY * (0.05 * (index + 1)) // Adjust this value for different parallax speeds
            return (
              <>
                <h3>{service.title}</h3>
                <div className={styles.servicecard} key={index} style={{ transform: `translateY(${cardY}px)` }}>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default ServicesSection

